import { render, staticRenderFns } from "./ShippingEstimate.vue?vue&type=template&id=0455b6ea&"
import script from "./ShippingEstimate.vue?vue&type=script&lang=js&"
export * from "./ShippingEstimate.vue?vue&type=script&lang=js&"
import style0 from "./ShippingEstimate.vue?vue&type=style&index=0&id=0455b6ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports